import {Bill} from '../../../app/interfaces/bill';
import {OptionHTMLAttributes} from 'react';
import {getSystem} from '../../../app/pages/dashboard/api';
import axios from 'axios';
import {ReclamationReason} from '../Type/reclamation';
import {Site} from "../../Auth/Types/type";
import {BuOption} from "../../../app/types/Customer";

export interface ReclamationForm {
    message: string;
}
export interface BillReclamationForm extends ReclamationForm {
    type?: OptionHTMLAttributes<string>;
    bill?: Bill;
    site?: Site;
    reason?: OptionHTMLAttributes<string>;
    subject?: string;
    file?: File;
    service?: any;
    customer?: BuOption;
}

interface AuthorizedReclamation {
    clientId: string;
    customerId?: string | number;
}

export interface TicketCreationResponse {
    TicketNumber?: string | number;
}

const OPEN_TICKET: string = 'api/reclamation/send';

export const postBillReclamation = async (reclamation: BillReclamationForm & AuthorizedReclamation ): Promise<TicketCreationResponse> => {
  const system = getSystem(reclamation.clientId);

  const formData = new FormData();

  formData.append('form', reclamation.reason?.value as string);

  if (reclamation.customerId !== undefined && reclamation.customerId !== null) {
    formData.append('customerId', reclamation.customerId.toString());
  }

  formData.append('datas[typeDemande]', reclamation.reason?.label as string);
  formData.append('datas[origine]', system);
  if (reclamation.subject) {
    formData.append('datas[objet]', reclamation.subject);
  }
  formData.append('datas[descriptif]', reclamation.message);

  if (reclamation.site) {
    formData.append('datas[siteService][0][id]', reclamation.site.id.toString());
    formData.append('datas[siteService][0][nom]', reclamation.site.name);
  }

  if (reclamation.service) {
    const serviceData = reclamation.service.data || reclamation.service;

    if (serviceData.serviceId) {
      formData.append('datas[service][serviceId]', serviceData.serviceId.toString());
    } else if (reclamation.service.value) {
      formData.append('datas[service][serviceId]', reclamation.service.value.toString());
    }

    if (serviceData.serviceName) {
      formData.append('datas[service][serviceName]', serviceData.serviceName);
    }

    if (serviceData.buId) {
      formData.append('datas[service][buId]', serviceData.buId.toString());
    }

    if (serviceData.buName) {
      formData.append('datas[service][buName]', serviceData.buName);
    }

    if (serviceData.type && Array.isArray(serviceData.type)) {
      formData.append('datas[service][type]', serviceData.type.join(', '));
    }
  }

  if (reclamation.bill) {
    formData.append('datas[facture][id]', reclamation.bill.id.toString());
  }

  if (reclamation.file) {
    formData.append('file', reclamation.file);
  }

  const response = await axios.post(OPEN_TICKET, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};


export const postReclamation = async (reclamation: ReclamationForm & AuthorizedReclamation) => {
    const system = getSystem(reclamation.clientId);

    const params = {
        form: ReclamationReason.DOCUMENT_REQUEST,
        datas: {
            typeDemande: ReclamationReason.DOCUMENT_REQUEST,
            origine: system,
            descriptif: reclamation.message,
            piecesJointes: [],
            contactClient: [
                {
                    email: 'test@celeste.fr',
                    name: 'Jean',
                },
            ],
        },
        username: 'test@celeste.fr',
    };

    const response = await axios.post(OPEN_TICKET, params);
    return response.data;
};
